<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <h3 class="text-center">{{$t('stock_damage')}}</h3>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table style="width: 100%;">
                        <tbody>
                        <tr>
                            <td style="width: 100px;">{{ $t('branch') }}</td>
                            <td style="width: 10px;">:</td>
                            <td>{{damage.BranchName}}</td>
                        </tr>
                        <tr>
                            <td>សំគាល់</td>
                            <td>:</td>
                            <td>{{damage.Remark}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table align="right">
                        <tbody>
                        <tr>
                            <td>{{$t('barcode')}}</td>
                            <td>:</td>
                            <td>{{damage.Num}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('date')}}</td>
                            <td>:</td>
                            <td>{{$format(damage.Date, 'DD/MM/YYYY')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                        <tr>
                            <th>{{$t('item_name')}}</th>
                            <th class="text-right">{{$t('description')}}</th>
                            <th class="text-right">{{$t('qty')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret,index) in lines" :key="index">
                            <td>{{ret.ItemName}}</td>
                            <td>{{ret.Description}}</td>
                            <td class="text-right">{{ret.Quantity}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "StockDamage",
        data() {
            return {
                company: '',
                damage: {
                    IsApproved: false
                },
                dateExchange: '',
                lines: []
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('stock/damage/find', {Id: id}).then(res => {
                    if (this.$isValid(res)) {
                        let data = res.data.Json;
                        this.damage = data.Header;
                        this.dateExchange = data.Header.Date;
                        this.lines = data.Lines;
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
</script>
